/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { useCurrentQueueItem } from "@packages/media";

import { MediaOptionsIcon } from "../../../../../components/_base/icons/Icon/MediaIcons";
import { ModalTab } from "../../../../../components/_base/modals/ModalTab/ModalTab.emotion";
import type { MediaMenuTabProps } from "../MediaMenu/MediaMenu.emotion";

export const SelectLengthTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const { currentItem } = useCurrentQueueItem();

  return (
    <ModalTab
      key={"lengthSelectMenuTab"}
      value={"lengthSelectMenu"}
      startIcon={<MediaOptionsIcon />}
      label={t("track_settings_length")}
      disabled={disabled}
    >
      {currentItem.selected_audio.length}
    </ModalTab>
  );
};
